// Libs
import React from 'react'

// CSS
import "./styles.scss"

const FeatureContact = () => {
  var fixedShapes = []
  var animatedShapes = []
  const shapesCount = 4
  const animatedCount = 5

  for (var i = 0; i < shapesCount; i++) {
    fixedShapes = [...fixedShapes, 'shape']
  }
  for (var i = 0; i < animatedCount; i++) {
    animatedShapes = [...animatedShapes, 'animatedShape']
  }

  return (
    <div className="feature-contact">
      {fixedShapes.map((item, idx) => (
        <span key={item + idx} className="feature-contact__shape" />
      ))}
      {animatedShapes.map((item, idx) => (
        <div key={item + idx} className="feature-contact__animated" />
      ))}
    </div>
  )
}

export default FeatureContact
